/**
 * AppLoadingIndicator Component
 * 
 * Displays a loading indicator during initial app load
 * Requirements: 19.1
 */

import { Spinner, Box } from '@cloudscape-design/components';
import './AppLoadingIndicator.css';

export function AppLoadingIndicator() {
  return (
    <div className="app-loading-indicator">
      <Box textAlign="center">
        <div className="app-loading-logo">
          {/* TTEC Digital logo placeholder */}
          <div className="logo-placeholder" />
        </div>
        <Spinner size="large" />
        <Box variant="p" color="text-body-secondary" margin={{ top: 's' }}>
          Loading TTEC Digital Agent Interface...
        </Box>
      </Box>
    </div>
  );
}
